<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-button @click.native="$modal.show('rental-form')">New rental</app-button>
        <app-input
          @input.native="onGroupsSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by id, group name, client"
          name="search"
        />
      </app-cells>
      <app-cells>
        <h2 class="title">Draft</h2>
      </app-cells>
      <v-client-table
        :data="table_draft.items"
        :columns="table_draft.columns"
        :options="table_draft.options"
        class="table-default"
        :class="{ 'table-default--loading': table_draft_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #h__client.name><div class="table-default__left">Client</div></template>
        <template #h__climbing_group.name><div class="table-default__left">Group</div></template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'rentals-detail', params: {id: row.id }}" class="table-default__link-border">
              Rental - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #client.name="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'clients-detail', params: {id: row.client.client.id }}" class="table-default__link-border">
              {{ row.client.client.full_name }}
            </router-link>
          </div>
        </template>
        <template #climbing_group.name="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'climbing-groups-detail-clients', params: {id: row.client.group.id }}" class="table-default__link-border">
              {{ row.client.group.name }}
            </router-link>
          </div>
        </template>
        <template #amount="{ row }">
          <span
            v-tooltip="{ content: amountTooltipContent(row), placement: 'left', offset: 10, html: true }"
          >
            {{ row.amount }}$
          </span>
        </template>
        <template #rental_start="{ row }">
          <span
            v-tooltip="{ content: 'Rental start expired', placement: 'top-start', offset: 10 }"
            v-if="row.start_expired"
            class="status-tag"
            :style="{ 'backgroundColor': '#e85c20' }"
          >
            {{ dateFormat(row.rental_start) }}
          </span>
          <span v-else>{{ dateFormat(row.rental_start) }}</span>
        </template>
        <template #rental_end="{ row }">
          {{ dateFormat(row.rental_end) }}
        </template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowDeleteModal(row.id)" type="button" ref="delete">
              <img src="@/assets/img/delete-table-icon.svg" alt="">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationDraft"
            v-if="pagination_draft.pages > 1"
            v-model="pagination_draft.page"
            :page-count="pagination_draft.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_draft.count" :count="table_draft.items.length" :page="pagination_draft.page" />
      </app-cells>
      <app-cells>
        <h2 class="title">In process</h2>
      </app-cells>
      <v-client-table
        :data="table_in_process.items"
        :columns="table_in_process.columns"
        :options="table_in_process.options"
        class="table-default"
        :class="{ 'table-default--loading': table_in_process_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #h__client><div class="table-default__left">Client</div></template>
        <template #h__climbing_group><div class="table-default__left">Group</div></template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'rentals-detail', params: {id: row.id }}" class="table-default__link-border">
              Rental - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #client="{ row }">
          <div class="table-default__left">
            <router-link v-if="row.client" :to="{name: 'clients-detail', params: {id: row.client.client.id }}" class="table-default__link-border">
              {{ row.client.client.full_name }}
            </router-link>
            <template v-else>-</template>
          </div>
        </template>
        <template #climbing_group="{ row }">
          <div class="table-default__left table-default__left--flex">
            <template v-if="row.client">
              <router-link
                :to="{ name: 'climbing-groups-detail-clients',params: { id: row.client.group.id } }"
                class="table-default__link-border"
              >
                {{ row.client.group.name }}
              </router-link>
              <span
                v-if="row.resupply && !row.resupply_fee"
                class="status-tag"
                :style="{ 'backgroundColor': '#f0c427' }"
              >
                Resupply
              </span>
              <span
                v-if="row.resupply && row.resupply_fee"
                class="status-tag"
                :style="{ 'backgroundColor': '#77b017' }"
              >
                Resupply
              </span>
              <span
                v-if="!row.resupply && row.resupply_fee"
                class="status-tag"
                :style="{ 'backgroundColor': '#e85c20' }"
              >
                Resupply
              </span>
            </template>
            <template v-else>-</template>
          </div>
        </template>
        <template #amount="{ row }">
          <span
            v-if="row.discount_amount && row.discount_amount > 0"
            class="status-tag"
            :style="{ 'backgroundColor': '#77b017' }"
            v-tooltip="{ content: `Discount: ${row.discount_amount}$<br>${row.discount_description || ''}`, placement: 'left', offset: 10, html: true }"
          >
            {{ row.amount }}$
          </span>
          <span
            v-else
            v-tooltip="{ content: amountTooltipContent(row), placement: 'left', offset: 10, html: true }"
          >
            {{ row.amount }}$
          </span>
        </template>
        <template #balance="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.balance === 0 ? '#77b017' : row.balance > 0 ? '#f0c427' :'#e85c20' }"
          >
            {{ row.balance === 0 ? 'Paid': `${row.balance}$` }}
          </span>
        </template>
        <template #returned="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.rental_items === row.rental_items_returned ? '#77b017' : '#e85c20' }"
          >
            {{ row.rental_items }} / {{ row.rental_items_returned }}
          </span>
        </template>
        <template #rental_start="{ row }">
          {{ dateFormat(row.rental_start) }}
        </template>
        <template #rental_end="{ row }">
          <span
            v-tooltip="{ content: 'Rental end expired', placement: 'top-start', offset: 10 }"
            v-if="row.end_expired"
            class="status-tag"
            :style="{ 'backgroundColor': '#e85c20' }"
          >
            {{ dateFormat(row.rental_end) }}
          </span>
          <span v-else>{{ dateFormat(row.rental_end) }}</span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationProcess"
            v-if="pagination_in_process.pages > 1"
            v-model="pagination_in_process.page"
            :page-count="pagination_in_process.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_in_process.count" :count="table_in_process.items.length" :page="pagination_in_process.page" />
      </app-cells>
      <modal
        name="rental-form"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
      >
        <div class="popup">
          <button @click="$modal.hide('rental-form')" class="popup__close" type="button"></button>
          <div class="popup__title">New rental</div>
          <div class="popup__body">
            <form @submit.prevent="onCheckForm">
              <app-form-group label="Group" required>
                <app-select
                  @search="onGroupSearch"
                  @input="onCheckGroup"
                  v-model="form.climbing_group"
                  :options="groups_options"
                  :clearable="false"
                  :display-field="option => `${option.name} (${dateFormat(option.tour_start)} - ${dateFormat(option.tour_end)})`"
                  placeholder="Group"
                  :error="$v.form.climbing_group.$error"
                />
                <template #error>
                  <div v-if="$v.form.climbing_group.$dirty && !$v.form.climbing_group.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Client" required>
                <app-select
                  v-model="form.client"
                  :options="clients_options"
                  :clearable="false"
                  :readonly="!form.climbing_group"
                  :get-option-label="item => item.client.full_name"
                  :display-field="option => option.client.full_name"
                  placeholder="Client"
                  :error="$v.form.client.$error"
                />
                <template #error>
                  <div v-if="$v.form.client.$dirty && !$v.form.client.required">Required field</div>
                </template>
              </app-form-group>
              <app-cells position="center" :indent="false">
                <app-button :disabled="$v.form.$error" type="submit" ref="submit">Start rental</app-button>
              </app-cells>
            </form>
          </div>
        </div>
      </modal>
      <modal
        name="delete-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
      >
        <div class="popup">
          <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
          <div class="popup__title popup__title--flex">
            <img src="@/assets/img/warning-round-icon.svg" alt="">
            Delete rental
          </div>
          <div class="popup__body">
            <div class="popup__subt">Are you sure you want to delete this rental?</div>
            <!--<div v-if="this.current_domain" class="popup__info">{{ this.current_domain.name }}</div>-->
            <app-cells position="center" :indent="false">
              <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
              <app-button @click.native="onDeleteRental(current_rental_id)" ref="delete">Yes</app-button>
            </app-cells>
          </div>
        </div>
      </modal>
    </template>
  </div>
</template>

<script>
import {
  deleteRental,
  getClimbingGroupsClients,
  getClimbingGroupsSearch,
  getRentals,
  getUsers,
  postRental,
} from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'

export default {
  name: 'RentalsActive',
  data() {
    return {
      is_loaded: false,
      search: '',
      table_draft: {
        items: [],
        columns: ['id', 'client.name', 'climbing_group.name', 'amount', 'rental_start', 'rental_end', 'controls'],
        options: {
          headings: {
            'id': 'ID',
            'client.name': 'Client',
            'climbing_group.name': 'Group',
            'amount': 'Amount',
            'rental_start': 'Start',
            'rental_end': 'End',
            'controls': ''
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_draft: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_in_process: {
        items: [],
        columns: ['id', 'client', 'climbing_group', 'amount', 'balance', 'returned', 'rental_start', 'rental_end'],
        options: {
          headings: {
            'id': 'ID',
            'client': 'Client',
            'climbing_group': 'Group',
            'amount': 'Amount',
            'balance': 'Balance',
            'returned': 'Returned',
            'rental_start': 'Start',
            'rental_end': 'End',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_in_process: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {
        climbing_group: '',
        client: '',
      },
      clients_options: [],
      groups_options: [],
      managers_options: [],
      current_rental_id: null,
      table_draft_preloader: false,
      table_in_process_preloader: false,
    }
  },
  validations: {
    form: {
      client: { required },
      climbing_group: { required },
    }
  },
  created() {
    Promise.all([
      getRentals({ page: this.pagination_draft.page, page_size: 20, status: 'draft', search: this.search, ordering: '-id' }),
      getRentals({ page: this.pagination_in_process.page, page_size: 20, status: 'in_process', search: this.search, ordering: 'rental_end' })
    ])
      .then(res => {
        this.table_draft.items = res[0].data.results
        this.pagination_draft.pages = res[0].data.pages
        this.pagination_draft.count = res[0].data.count

        this.table_in_process.items = res[1].data.results
        this.pagination_in_process.pages = res[1].data.pages
        this.pagination_in_process.count = res[1].data.count

        this.is_loaded = true
      })
    getUsers({ group: 'operations_manager', is_active: true }).then(response => {
      this.managers_options = response.data
    })
  },
  methods: {
    onChangeFilter() {
      this.search = ''
      this.table_in_process_preloader = true
      this.pagination_in_process.page = 1
      this.fetchItemsProcess()
    },
    onClickPaginationDraft(page) {
      this.table_draft_preloader = true
      this.pagination_draft.page = page
      this.fetchItemsDraft()
    },
    onClickPaginationProcess(page) {
      this.table_in_process_preloader = true
      this.pagination_in_process.page = page
      this.fetchItemsProcess()
    },
    onCheckGroup() {
      getClimbingGroupsClients(this.form.climbing_group.id)
        .then(res => {
          this.clients_options = res.data
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : ''
    },
    fetchItemsDraft() {
      getRentals({ page: this.pagination_draft.page, page_size: 20, status: 'draft', search: this.search, ordering: '-id' }).then(res => {
        this.table_draft.items = res.data.results
        this.pagination_draft.pages = res.data.pages
        this.pagination_draft.count = res.data.count
        this.table_draft_preloader = false
      })
    },
    fetchItemsProcess() {
      const params = {
        page: this.pagination_in_process.page,
        page_size: 20,
        status: 'in_process',
        search: this.search,
        ordering: 'rental_end'
      }
      getRentals(params)
        .then(res => {
          this.table_in_process.items = res.data.results
          this.pagination_in_process.pages = res.data.pages
          this.pagination_in_process.count = res.data.count
          this.is_loaded = true
          this.table_in_process_preloader = false
        })
    },
    onCheckForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      postRental({
        client: this.form.client.id
      })
        .finally(() => { this.$refs.submit.preload = false })
        .then(res => {
          this.$notify({
            type: 'success',
            title: 'Rental created',
          })
          this.$modal.hide('rental-form')
          this.form = {}
          this.$router.push({ name: 'rentals-detail', params: { id: res.data.id } })
        })
    },
    onGroupsSearch() {
      this.searchGroups(this)
    },
    searchGroups: debounce(vm => {
      vm.pagination_draft.page = 1
      vm.pagination_in_process.page = 1
      vm.fetchItemsDraft()
      vm.fetchItemsProcess()
    }, 350),
    onGroupSearch(search, loading) {
      loading(true)
      this.searchGroup(loading, search, this)
    },
    searchGroup: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.groups_options = []
      } else {
        getClimbingGroupsSearch({ category: 'upcoming', search }).then(response => {
          vm.groups_options = response.data
          loading(false)
        })
      }
    }, 350),
    onShowDeleteModal(id) {
      this.current_rental_id = id
      this.$modal.show('delete-modal')
    },
    onDeleteRental(id) {
      this.$refs.delete.preload = true
      deleteRental(id)
        .finally(() => { this.$refs.delete.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Rental deleted',
          })
          this.$modal.hide('delete-modal')
          this.vm.fetchItemsDraft()
        })
    },
    amountTooltipContent(data) {
      let content = `Rental: ${data.amount_rental}$<br>Purchase: ${data.amount_sale}$`
      if (data.resupply_fee) content += '<br>Resupply: 50$'
      if (data.discount_method) content += `<br>Discount: ${data.discount_method.code === 'basic' ? `${data.discount}$` : `${data.discount}%`}`
      return content
    },
  }
}
</script>
